"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateCartItemRequest = instanceOfUpdateCartItemRequest;
exports.UpdateCartItemRequestFromJSON = UpdateCartItemRequestFromJSON;
exports.UpdateCartItemRequestFromJSONTyped = UpdateCartItemRequestFromJSONTyped;
exports.UpdateCartItemRequestToJSON = UpdateCartItemRequestToJSON;
exports.UpdateCartItemRequestToJSONTyped = UpdateCartItemRequestToJSONTyped;
/**
 * Check if a given object implements the UpdateCartItemRequest interface.
 */
function instanceOfUpdateCartItemRequest(value) {
    return true;
}
function UpdateCartItemRequestFromJSON(json) {
    return UpdateCartItemRequestFromJSONTyped(json, false);
}
function UpdateCartItemRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cartItemNo': json['cartItemNo'] == null ? undefined : json['cartItemNo'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}
function UpdateCartItemRequestToJSON(json) {
    return UpdateCartItemRequestToJSONTyped(json, false);
}
function UpdateCartItemRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cartItemNo': value['cartItemNo'],
        'quantity': value['quantity'],
    };
}
